// extracted by mini-css-extract-plugin
export default {"separator":"Bundle-separator-Vs4","reviewsAndQa":"Bundle-reviewsAndQa-cNo"};